import { $api } from "../../../../../services/request.config";
import { getAvailableEmployeesDelegationAction } from "../getAvailableEmployeesDelegation.action";
import { clearAvailableEmployeesDelegationAction } from "../clearAvailableEmployeesDelegation.action";
export const getAvailableEmployeesDelegationThunkAction = () => async (dispatch) => {
    try {
        //v1/manager/substitutions/eligible-substitutes
        // dispatch(clearAvailableEmployeesDelegationAction());
        const response = await $api("v1/manager/substitutions/eligible-substitutes");

        // const response = await $api("v1/managers/requests/rvd/subordinates");

        if (response.status === 200) {
            dispatch(getAvailableEmployeesDelegationAction(response.data));
        }
    } catch (error) {
        dispatch(getAvailableEmployeesDelegationAction([]));
        // throw new Error("")
        // console.log("ERROR WHILE GETTING AVAILABLE EMPLOYEES: ", error);
    }
};
